import { useState } from 'react';
import { MdAdminPanelSettings, MdPersonAddAlt1, MdVisibility, MdVisibilityOff } from 'react-icons/md';
import { Oval } from 'react-loader-spinner';
import BoxAlert from '../../components/boxAlert';
import Header from '../../components/header';
import axios from '../../services/axios-config';
import styles from './css/registerUser.module.css';


const MIN_PASSWORD_LENGTH = 6;
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;


export default function RegisterUser(){


    // USER DATA CONTROLLER
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [master, setMaster] = useState(false);

    // CONTROLE VISUAL
    const [showPassword, setShowPassword] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    // LOADING CONTROLLER
    const [loading, setLoading] = useState(false);

    // ALERTS CONTROLLER
    const [warnAlert, setWarnAlert] = useState({show: false, title: null, text: null});


    // VALIDAÇÃO DOS CAMPOS: CADA CHAVE É A MENSAGEM DE ERRO DO CAMPO (AUSENTE = CAMPO VÁLIDO)
    const errors = {};

    if(!name.trim()) errors.name = 'Informe o nome do administrador.';

    if(!email.trim()) errors.email = 'Informe o e-mail.';
    else if(!EMAIL_REGEX.test(email.trim())) errors.email = 'Informe um e-mail válido.';

    if(!password) errors.password = 'Informe uma senha.';
    else if(password.length < MIN_PASSWORD_LENGTH) errors.password = `A senha deve ter pelo menos ${MIN_PASSWORD_LENGTH} caracteres.`;

    if(!confirmPassword) errors.confirmPassword = 'Confirme a senha.';
    else if(password !== confirmPassword) errors.confirmPassword = 'As senhas não coincidem.';

    // ERROS DE VALIDAÇÃO SÓ APARECEM DEPOIS DA PRIMEIRA TENTATIVA DE ENVIO,
    // EXCETO A CONFIRMAÇÃO DE SENHA, QUE É AVISADA ASSIM QUE O USUÁRIO COMEÇA A DIGITAR
    const showError = (field) => {
        if(!errors[field]) return null;
        if(submitted) return errors[field];
        if(field === 'confirmPassword' && confirmPassword && password !== confirmPassword) return errors[field];
        return null;
    };


    const handleRegisterUser = async (event) => {
        event.preventDefault();

        if(loading) return;

        setSubmitted(true);

        if(Object.keys(errors).length > 0){
            return;
        }

        try{
            setLoading(true);

            const res = await axios.post(`/admin/register`, {
                name: name.trim(),
                email: email.trim(),
                password: password,
                master: master
            })


            if(res.status == 201){
                setWarnAlert({show: true, title: 'Sucesso', text: `O administrador ${name.trim()} foi cadastrado com sucesso!`});

                setName('');
                setEmail('');
                setPassword('');
                setConfirmPassword('');
                setMaster(false);
                setShowPassword(false);
                setSubmitted(false);
            }

        } catch (error) {
            console.error('ERROR - REGISTER USER HANDLER:', error);
            setWarnAlert({show: true, title: 'Erro', text: error?.response?.data?.error ?? 'Não foi possível cadastrar o administrador no momento. Tente novamente em instantes.'})

        } finally {
            setLoading(false);
        }
    }


    const renderField = ({ field, label, type, placeholder, value, onChange, autoComplete }) => (
        <div className={styles.field}>
            <label className={styles.inputLabel} htmlFor={field}>{label}</label>

            <div className={`${styles.inputWrapper} ${showError(field) ? styles.inputInvalid : ''}`}>
                <input
                    id={field}
                    className={styles.boxInput}
                    type={type}
                    placeholder={placeholder}
                    value={value}
                    autoComplete={autoComplete}
                    onChange={({target: {value}}) => onChange(value)}
                />

                {(field === 'password' || field === 'confirmPassword') && (
                    <button
                        type='button'
                        className={styles.toggleVisibility}
                        onClick={() => setShowPassword((prev) => !prev)}
                        aria-label={showPassword ? 'Ocultar senhas' : 'Mostrar senhas'}
                    >
                        {showPassword ? <MdVisibilityOff size={20} /> : <MdVisibility size={20} />}
                    </button>
                )}
            </div>

            {showError(field) && <p className={styles.errorText}>{showError(field)}</p>}
        </div>
    );



    // SCREEN ==============================================>

    return (
        <>
            <Header>
                <h2 style={{color: '#fff'}}>Registrar usuário</h2>
            </Header>


            <div className={styles.screen}>

                <div className={styles.container}>

                    <form className={styles.formCard} onSubmit={handleRegisterUser} noValidate>

                        <div className={styles.formHeader}>
                            <div className={styles.headerIcon}>
                                <MdPersonAddAlt1 size={28} />
                            </div>

                            <div>
                                <h3 className={styles.formTitle}>Novo administrador</h3>
                                <p className={styles.formSubtitle}>Cadastre um novo administrador do painel SofChef.</p>
                            </div>
                        </div>

                        <div className={styles.fieldsGrid}>
                            {renderField({ field: 'name', label: 'Nome de usuário *', type: 'text', placeholder: 'Ex: Maria Silva', value: name, onChange: setName, autoComplete: 'off' })}
                            {renderField({ field: 'email', label: 'E-mail *', type: 'email', placeholder: 'nome@empresa.com', value: email, onChange: setEmail, autoComplete: 'off' })}
                            {renderField({ field: 'password', label: 'Senha *', type: showPassword ? 'text' : 'password', placeholder: `Mínimo de ${MIN_PASSWORD_LENGTH} caracteres`, value: password, onChange: setPassword, autoComplete: 'new-password' })}
                            {renderField({ field: 'confirmPassword', label: 'Confirmar senha *', type: showPassword ? 'text' : 'password', placeholder: 'Repita a senha', value: confirmPassword, onChange: setConfirmPassword, autoComplete: 'new-password' })}
                        </div>

                        <label className={`${styles.permissionCard} ${master ? styles.permissionActive : ''}`}>
                            <div className={styles.permissionIcon}>
                                <MdAdminPanelSettings size={24} />
                            </div>

                            <div className={styles.permissionInfo}>
                                <p className={styles.permissionTitle}>Controla usuários</p>
                                <p className={styles.permissionText}>Permite que este administrador cadastre novos administradores no painel.</p>
                            </div>

                            <input
                                className={styles.boxCheckbox}
                                type='checkbox'
                                checked={master}
                                onChange={({target: {checked}}) => setMaster(checked)}
                            />
                        </label>

                        <button type='submit' className={styles.registerButton} disabled={loading}>
                            {loading ? (
                                <Oval
                                    visible={true}
                                    height="24"
                                    width="24"
                                    color="#fff"
                                    secondaryColor="rgba(255,255,255,0.4)"
                                    ariaLabel="oval-loading"
                                />

                            ) : (
                                <span className={styles.textRegisterButton}>Registrar usuário</span>
                            )}
                        </button>
                    </form>
                </div>

                <BoxAlert
                    show={warnAlert.show}
                    title={warnAlert.title}
                    text={warnAlert.text}
                    onClose={() => setWarnAlert({show: false, title: null, text: null})}
                />

            </div>
        </>
    )
}
